import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, vModelCheckbox as _vModelCheckbox, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3006e440"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-6" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "flex items-center" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "61",
  height: "56",
  viewBox: "0 0 61 56",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M19.6624 45.8393H23.4556C25.9327 45.8393 27.868 43.8227 27.868 41.4183V37.6177C27.868 35.1357 25.8553 33.1967 23.4556 33.1967H19.6624C17.1853 33.1967 15.25 35.2133 15.25 37.6177V41.4183C15.25 43.8227 17.2627 45.8393 19.6624 45.8393Z",
    fill: "#1C1C1C"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M58.4454 20.3989H58.2906L56.5101 6.67036C55.9683 2.86981 52.717 0 48.9239 0H12.0761C8.28299 0 5.03173 2.86981 4.48985 6.67036L2.70939 20.3989H2.55457C1.16117 20.3989 0 21.5623 0 22.9585C0 24.3546 1.16117 25.518 2.55457 25.518H5.10914V48.4765C5.10914 52.6648 8.51523 56.1551 12.7728 56.1551H48.382C52.5622 56.1551 56.0457 52.7424 56.0457 48.4765V25.4404H58.6002C59.9936 25.4404 61.1548 24.277 61.1548 22.8809C61 21.4848 59.8388 20.3989 58.4454 20.3989ZM33.0546 5.11911H39.7119L41.7246 20.3989H33.0546V5.11911ZM21.2881 5.11911H27.9454V20.3989H19.2754L21.2881 5.11911ZM9.52157 7.29086C9.6764 6.04986 10.7602 5.04155 12.0761 5.04155H16.1789L14.1662 20.3213H7.81853L9.52157 7.29086ZM50.8591 48.3989C50.8591 49.795 49.698 50.9585 48.3046 50.9585H45.75V37.5402C45.75 35.0582 43.7373 33.1191 41.3376 33.1191H37.5444C35.0673 33.1191 33.132 35.1357 33.132 37.5402V50.8809H12.6954C11.302 50.8809 10.1409 49.7175 10.1409 48.3213V25.4404H50.7817V48.3989H50.8591ZM46.9112 20.3989L44.8211 5.11911H48.9239C50.1624 5.11911 51.2462 6.04986 51.4784 7.36842L53.1815 20.4765H46.9112V20.3989Z",
    fill: "#1C1C1C"
  })
], -1))
const _hoisted_5 = { class: "font-bold text-lg text-black px-2" }
const _hoisted_6 = { class: "mt-6 mb-2 font-bold text-black" }
const _hoisted_7 = { class: "flex gap-6 w-1/2" }
const _hoisted_8 = { class: "flex-1 me-4" }
const _hoisted_9 = { class: "font-bold text-dark my-1" }
const _hoisted_10 = ["placeholder"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "my-4" }, null, -1))
const _hoisted_12 = { class: "mt-6 mb-2 font-bold text-black" }
const _hoisted_13 = { class: "flex gap-6" }
const _hoisted_14 = { class: "flex items-center gap-x-2" }
const _hoisted_15 = { class: "font-bold text-dark text-xs" }
const _hoisted_16 = ["placeholder"]
const _hoisted_17 = { class: "flex items-center gap-x-2" }
const _hoisted_18 = { class: "font-bold text-dark text-xs" }
const _hoisted_19 = ["placeholder"]
const _hoisted_20 = { class: "mt-6 flex items-center gap-6" }
const _hoisted_21 = { class: "flex items-center gap-x-2" }
const _hoisted_22 = { class: "font-bold text-dark text-xs" }
const _hoisted_23 = ["value"]
const _hoisted_24 = { class: "flex items-center gap-x-2" }
const _hoisted_25 = { class: "font-bold text-dark text-xs" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "my-4" }, null, -1))
const _hoisted_27 = { class: "mt-6 mb-2 font-bold text-black flex items-center gap-x-2" }
const _hoisted_28 = { class: "flex gap-6" }
const _hoisted_29 = { class: "p-1" }
const _hoisted_30 = { class: "p-1" }
const _hoisted_31 = { class: "p-1" }
const _hoisted_32 = { class: "p-1" }
const _hoisted_33 = { class: "p-1" }
const _hoisted_34 = { class: "p-1" }
const _hoisted_35 = { class: "pt-3" }
const _hoisted_36 = { class: "h-5 w-220 rounded-xl bg-gray-100 position-relative overflow-hidden" }
const _hoisted_37 = { class: "pt-4" }
const _hoisted_38 = { class: "h-5 w-220 rounded-xl bg-gray-100 position-relative overflow-hidden" }
const _hoisted_39 = { class: "pt-4" }
const _hoisted_40 = { class: "h-5 w-220 rounded-xl bg-gray-100 position-relative overflow-hidden" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "my-4" }, null, -1))
const _hoisted_42 = { class: "mt-6 mb-2 font-bold text-black" }
const _hoisted_43 = { class: "flex gap-6" }
const _hoisted_44 = { class: "flex items-center gap-x-2" }
const _hoisted_45 = { class: "font-bold text-dark text-xs" }
const _hoisted_46 = ["placeholder"]
const _hoisted_47 = { class: "flex items-center gap-x-2" }
const _hoisted_48 = { class: "font-bold text-dark text-xs" }
const _hoisted_49 = ["placeholder"]
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "my-4" }, null, -1))
const _hoisted_51 = { class: "mt-6 mb-2 font-bold text-black" }
const _hoisted_52 = { class: "flex gap-6 items-start" }
const _hoisted_53 = { class: "font-bold text-dark mt-3" }
const _hoisted_54 = { class: "flex-1 mr-12 range-wrap relative" }
const _hoisted_55 = {
  ref: "rangeV",
  class: "range-value rounded py-1",
  id: "rangeV"
}
const _hoisted_56 = { class: "flex justify-between" }
const _hoisted_57 = { class: "flex gap-9 items-start pt-7" }
const _hoisted_58 = { class: "flex items-center" }
const _hoisted_59 = { class: "flex items-center" }
const _hoisted_60 = { class: "mt-6 flex justify-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseIcon = _resolveComponent("BaseIcon")!
  const _component_Popper = _resolveComponent("Popper")!
  const _component_DarkstoreSettingsInput = _resolveComponent("DarkstoreSettingsInput")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.darkstore.name), 1)
      ]),
      _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('darkstoreSettings.contactInformation')), 1),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('darkstoreSettings.email_address')), 1),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.email_address) = $event)),
            type: "text",
            placeholder: _ctx.$t('placeholders.email'),
            class: "h-42 bg-white input px-2 w-full"
          }, null, 8, _hoisted_10), [
            [_vModelText, _ctx.form.email_address]
          ])
        ])
      ]),
      _hoisted_11,
      _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t('darkstoreSettings.details')), 1),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.$t('darkstoreSettings.max_threshold_waiting_time')), 1),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.max_threshold_waiting_time) = $event)),
            type: "number",
            placeholder: _ctx.$t('darkstoreSettings.max_threshold_waiting_time'),
            class: "bg-white input px-2 w-18 settings-input",
            min: "1"
          }, null, 8, _hoisted_16), [
            [_vModelText, _ctx.form.max_threshold_waiting_time]
          ])
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.$t('darkstoreSettings.max_orders_assigned')), 1),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.max_orders_assigned) = $event)),
            type: "number",
            placeholder: _ctx.$t('darkstoreSettings.max_orders_assigned'),
            class: "bg-white input px-2 w-18 settings-input",
            min: "1"
          }, null, 8, _hoisted_19), [
            [_vModelText, _ctx.form.max_orders_assigned]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.$t('darkstoreSettings.order_distribution')), 1),
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.score_divisor) = $event)),
            id: "distributions",
            name: "distributions",
            class: "bg-white input px-2 settings-input",
            style: {"width":"100px"}
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.distributions, (item) => {
              return (_openBlock(), _createElementBlock("option", {
                key: item.value,
                value: item.value
              }, _toDisplayString(item.label), 9, _hoisted_23))
            }), 128))
          ], 512), [
            [_vModelSelect, _ctx.form.score_divisor]
          ])
        ]),
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("div", _hoisted_25, [
            _createVNode(_component_Popper, {
              arrow: "",
              hover: "",
              placement: "auto"
            }, {
              content: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('darkstoreSettings.driver_balance_limit_info')), 1)
              ]),
              default: _withCtx(() => [
                _createVNode(_component_BaseIcon, {
                  name: "info",
                  "class-names": "w-4 h-4"
                }),
                _createTextVNode(" " + _toDisplayString(_ctx.$t('darkstoreSettings.driver_balance_limit')) + " ", 1)
              ]),
              _: 1
            })
          ]),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.driver_balance_limit) = $event)),
            type: "number",
            placeholder: 1,
            class: "bg-white input px-2 w-18 settings-input",
            min: "1"
          }, null, 512), [
            [_vModelText, _ctx.form.driver_balance_limit]
          ])
        ])
      ]),
      _hoisted_26,
      _createElementVNode("div", _hoisted_27, [
        _createTextVNode(_toDisplayString(_ctx.$t('Delivery Settings')) + " ", 1),
        _createVNode(_component_Popper, {
          arrow: "",
          hover: "",
          placement: "auto"
        }, {
          content: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("darkstoreSettings.totalSettingsInfo")), 1)
          ]),
          default: _withCtx(() => [
            _createVNode(_component_BaseIcon, { name: "info" })
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_28, [
        _createElementVNode("div", null, [
          _createElementVNode("div", null, [
            _createElementVNode("table", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("td", _hoisted_29, _toDisplayString(_ctx.$t('darkstoreSettings.delivered_orders_count_weight')), 1),
                _createElementVNode("td", _hoisted_30, [
                  _createVNode(_component_DarkstoreSettingsInput, {
                    modelValue: _ctx.form.delivered_orders_count_weight,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.delivered_orders_count_weight) = $event)),
                    total: _ctx.total,
                    "onUpdate:lockValue": _cache[6] || (_cache[6] = (v) => _ctx.delivered_orders_count_weight_lock = v),
                    onInput: _cache[7] || (_cache[7] = ($event: any) => (_ctx.onSettingsInputHandler('delivered_orders_count_weight')))
                  }, null, 8, ["modelValue", "total"])
                ])
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("td", _hoisted_31, _toDisplayString(_ctx.$t('darkstoreSettings.delivered_orders_distance_weight')), 1),
                _createElementVNode("td", _hoisted_32, [
                  _createVNode(_component_DarkstoreSettingsInput, {
                    modelValue: _ctx.form.delivered_orders_distance_weight,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.delivered_orders_distance_weight) = $event)),
                    total: _ctx.total,
                    "onUpdate:lockValue": _cache[9] || (_cache[9] = (v) => _ctx.delivered_orders_distance_weight_lock = v),
                    onInput: _cache[10] || (_cache[10] = ($event: any) => (_ctx.onSettingsInputHandler('delivered_orders_distance_weight')))
                  }, null, 8, ["modelValue", "total"])
                ])
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("td", _hoisted_33, _toDisplayString(_ctx.$t('darkstoreSettings.waiting_time_at_the_darkstore_weight')), 1),
                _createElementVNode("td", _hoisted_34, [
                  _createVNode(_component_DarkstoreSettingsInput, {
                    modelValue: _ctx.form.waiting_time_at_the_darkstore_weight,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.form.waiting_time_at_the_darkstore_weight) = $event)),
                    total: _ctx.total,
                    "onUpdate:lockValue": _cache[12] || (_cache[12] = (v) => _ctx.waiting_time_at_the_darkstore_weight_lock = v),
                    onInput: _cache[13] || (_cache[13] = ($event: any) => (_ctx.onSettingsInputHandler('waiting_time_at_the_darkstore_weight')))
                  }, null, 8, ["modelValue", "total"])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("table", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("td", _hoisted_35, [
                _createElementVNode("div", _hoisted_36, [
                  _createElementVNode("div", {
                    class: "position-absolute bg-red-400 h-5 rounded-xl",
                    style: _normalizeStyle({'width': `${_ctx.form.delivered_orders_count_weight}%`})
                  }, null, 4)
                ])
              ])
            ]),
            _createElementVNode("tr", null, [
              _createElementVNode("td", _hoisted_37, [
                _createElementVNode("div", _hoisted_38, [
                  _createElementVNode("div", {
                    class: "position-absolute bg-red-400 h-5 rounded-xl",
                    style: _normalizeStyle({'width': `${_ctx.form.delivered_orders_distance_weight}%`})
                  }, null, 4)
                ])
              ])
            ]),
            _createElementVNode("tr", null, [
              _createElementVNode("td", _hoisted_39, [
                _createElementVNode("div", _hoisted_40, [
                  _createElementVNode("div", {
                    class: "position-absolute bg-red-400 h-5 rounded-xl",
                    style: _normalizeStyle({'width': `${_ctx.form.waiting_time_at_the_darkstore_weight}%`})
                  }, null, 4)
                ])
              ])
            ])
          ])
        ])
      ]),
      _hoisted_41,
      _createElementVNode("div", _hoisted_42, _toDisplayString(_ctx.$t('darkstoreSettings.temporalSettings')), 1),
      _createElementVNode("div", _hoisted_43, [
        _createElementVNode("div", _hoisted_44, [
          _createElementVNode("div", _hoisted_45, _toDisplayString(_ctx.$t('darkstoreSettings.interval_time')), 1),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.form.interval_time) = $event)),
            type: "number",
            placeholder: _ctx.$t('darkstoreSettings.interval_time'),
            class: "bg-white input px-2 w-18 settings-input",
            min: "1"
          }, null, 8, _hoisted_46), [
            [_vModelText, _ctx.form.interval_time]
          ])
        ]),
        _createElementVNode("div", _hoisted_47, [
          _createElementVNode("div", _hoisted_48, _toDisplayString(_ctx.$t('darkstoreSettings.interval_based_order_weighting')), 1),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.form.interval_weight) = $event)),
            type: "number",
            placeholder: _ctx.$t('darkstoreSettings.interval_based_order_weighting'),
            class: "bg-white input px-2 w-18 settings-input",
            min: "1"
          }, null, 8, _hoisted_49), [
            [_vModelText, _ctx.form.interval_weight]
          ])
        ])
      ]),
      _hoisted_50,
      _createElementVNode("div", _hoisted_51, _toDisplayString(_ctx.$t('darkstoreSettings.distanceSettings')), 1),
      _createElementVNode("div", _hoisted_52, [
        _createElementVNode("div", _hoisted_53, _toDisplayString(_ctx.$t('darkstoreSettings.max_distance_from_dark_store')), 1),
        _createElementVNode("div", _hoisted_54, [
          _createElementVNode("div", _hoisted_55, null, 512),
          _withDirectives(_createElementVNode("input", {
            id: "range",
            type: "range",
            ref: "range",
            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.form.max_distance_from_dark_store) = $event)),
            min: "0",
            max: "800",
            class: "w-full range-selector"
          }, null, 512), [
            [_vModelText, _ctx.form.max_distance_from_dark_store]
          ]),
          _createElementVNode("div", _hoisted_56, [
            _createElementVNode("div", null, "0 " + _toDisplayString(_ctx.$t('darkstoreSettings.meter')), 1),
            _createElementVNode("div", null, "800 " + _toDisplayString(_ctx.$t('darkstoreSettings.meter')), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_57, [
        _createElementVNode("div", _hoisted_58, [
          _withDirectives(_createElementVNode("input", {
            name: "auto_assignment",
            id: "auto_assignment",
            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.form.stop_auto_assignment) = $event)),
            type: "checkbox"
          }, null, 512), [
            [_vModelCheckbox, _ctx.form.stop_auto_assignment]
          ]),
          _createElementVNode("div", {
            role: "button",
            class: "font-bold text-dark my-1 px-1",
            onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.form.stop_auto_assignment = !_ctx.form.stop_auto_assignment))
          }, _toDisplayString(_ctx.$t('darkstoreSettings.stop_auto_assignment')), 1)
        ]),
        _createElementVNode("div", _hoisted_59, [
          _withDirectives(_createElementVNode("input", {
            name: "auto_clock_out",
            id: "auto_clock_out",
            "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.form.stop_auto_clock_out) = $event)),
            type: "checkbox"
          }, null, 512), [
            [_vModelCheckbox, _ctx.form.stop_auto_clock_out]
          ]),
          _createElementVNode("div", {
            role: "button",
            class: "font-bold text-dark my-1 px-1",
            onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.form.stop_auto_clock_out = !_ctx.form.stop_auto_clock_out))
          }, _toDisplayString(_ctx.$t('darkstoreSettings.stop_auto_clock_out')), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_60, [
      _createElementVNode("button", {
        class: "primary flex items-center px-5 py-3",
        onClick: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.updateSettings && _ctx.updateSettings(...args)))
      }, _toDisplayString(_ctx.$t('buttons.saveChanges')), 1)
    ])
  ]))
}